import { render, staticRenderFns } from "./aboutPage.vue?vue&type=template&id=52b2ed2e&scoped=true&"
import script from "./aboutPage.vue?vue&type=script&lang=js&"
export * from "./aboutPage.vue?vue&type=script&lang=js&"
import style0 from "./aboutPage.vue?vue&type=style&index=0&id=52b2ed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2ed2e",
  null
  
)

export default component.exports